var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _circle, _rect8, _g, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 298 301",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 160.3,
    width: 296.5,
    height: 140.5,
    rx: 9.8,
    fill: "#fff",
    fillOpacity: 0.1,
    stroke: "#ECECEC",
    strokeWidth: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 110.9,
    y: 182,
    width: 173.4,
    height: 111,
    rx: 10,
    fill: "#F7F9FC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 110.9,
    y: 172.7,
    width: 49.7,
    height: 3.5,
    rx: 1.7,
    fill: "#F7F9FC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 90.1,
    height: 120.2,
    rx: 4,
    transform: "matrix(-1 0 0 1 103 173)",
    fill: "#F7F9FC"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 23.1,
    y: 202.8,
    width: 38.1,
    height: 3.5,
    rx: 1.7,
    fill: "#F8FAFD"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 19.6,
    y: 177.3,
    width: 76.3,
    height: 40.5,
    rx: 4,
    fill: "#fff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 24.8,
    y: 183.2,
    width: 23.6,
    height: 3.2,
    rx: 1.6,
    fill: "#F8FAFD"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 88.4,
    cy: 184.7,
    r: 2.6,
    fill: "#F8FAFD"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 24.8,
    y: 189.1,
    width: 13.1,
    height: 3.2,
    rx: 1.6,
    fill: "#F8FAFD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.6,
    y: 224.7,
    width: 76.3,
    height: 60.1,
    rx: 4,
    fill: "#fff"
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 22.5,
    y: 232.9,
    width: 30.3,
    height: 3.2,
    rx: 1.6,
    fill: "#F8FAFD"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 22.5,
    y: 237.5,
    width: 23.8,
    height: 3.2,
    rx: 1.6,
    fill: "#F8FAFD"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 22.5,
    y: 228,
    width: 13.1,
    height: 1.9,
    rx: 0.9,
    fill: "#F8FAFD"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 22.5,
    y: 251.4,
    width: 13.1,
    height: 1.9,
    rx: 0.9,
    fill: "#F8FAFD"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 0.3,
    y: 0.3,
    width: 296.5,
    height: 140.5,
    rx: 9.8,
    fill: "#fff",
    fillOpacity: 0.1,
    stroke: "#ECECEC",
    strokeWidth: 0.5
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 22,
    width: 84,
    height: 111,
    rx: 10,
    fill: "#F7F9FC"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 12.7,
    width: 22,
    height: 3.5,
    rx: 1.7,
    fill: "#F7F9FC"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 69.3,
    height: 120.2,
    rx: 4,
    transform: "matrix(-1 0 0 1 82 13)",
    fill: "#F7F9FC"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 20.7,
    y: 42.8,
    width: 29.3,
    height: 3.5,
    rx: 1.7,
    fill: "#F8FAFD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 11.6,
    y: 220.7,
    width: 92.3,
    height: 76.1,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.840861 0 0 0 0 0.855826 0 0 0 0 0.885756 0 0 0 0.151961 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6170_3221"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_6170_3221",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreen);
export default __webpack_public_path__ + "static/media/screen.7c7af40b.svg";
export { ForwardRef as ReactComponent };